import React, { useState, useContext, useEffect, useMemo, useRef } from "react"

import NumberPad from "./NumberPad"

export const dateToYMD = (date) => {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();

    return year + "-" + padWithLeadingZeros(month) + "-" + padWithLeadingZeros(day) + " " + padWithLeadingZeros(hours) + ":" + padWithLeadingZeros(minutes) + ":" + padWithLeadingZeros(seconds);
}

export const padWithLeadingZeros = (num, totalLength = 2) => {
    return String(num).padStart(totalLength, '0');
}

export const dateAdd = (date, interval, units) => {
    if (!(date instanceof Date))
        return undefined;
    var ret = new Date(date); //don't change original date
    var checkRollover = function () { if (ret.getDate() != date.getDate()) ret.setDate(0); };
    switch (String(interval).toLowerCase()) {
        case 'year': ret.setFullYear(ret.getFullYear() + units); checkRollover(); break;
        case 'quarter': ret.setMonth(ret.getMonth() + 3 * units); checkRollover(); break;
        case 'month': ret.setMonth(ret.getMonth() + units); checkRollover(); break;
        case 'week': ret.setDate(ret.getDate() + 7 * units); break;
        case 'day': ret.setDate(ret.getDate() + units); break;
        case 'hour': ret.setTime(ret.getTime() + units * 3600000); break;
        case 'minute': ret.setTime(ret.getTime() + units * 60000); break;
        case 'second': ret.setTime(ret.getTime() + units * 1000); break;
        default: ret = undefined; break;
    }
    return ret;
}

export const todayDatetime = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    var hours = String(today.getHours()).padStart(2, '0');
    var minutes = String(today.getMinutes()).padStart(2, '0');
    var seconds = String(today.getSeconds()).padStart(2, '0');

    return dd + '.' + mm + '.' + yyyy + ' ' + hours + ':' + minutes + ':' + seconds
}

const error = (message) => {
    return {
        status: false,
        message: message
    }
}

const print = async (printerIP, data) => {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token') ?? false
    if (token) {
        myHeaders.append('ManagerToken', token)
    }

    try {
        const response = await fetch(
            printerIP,
            {
                credentials: 'include',
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(data)
            },
        );
        const responseJSON = await response.json();

        if (responseJSON.status.result == 'ERROR') {
            const message = responseJSON.status.message ?? 'Произошла ошибка при выполнении запроса!';
            return error(message)
        }

        return {
            status: true,
            data: responseJSON.data,
            message: responseJSON.status.message
        }
    } catch (error) {
            const message = 'Произошла ошибка при выполнении запроса!';
            return message
    }
}

const ProductionInterface = ({ onClose, product, printerIP, user }) => {
    const [amount, setAmount] = useState('')
    const [isPrinting, setIsPrinting] = useState(false)

    const [weight, setWeight] = useState(0)
    const [gettingWeight, setGettingWeight] = useState(false)

    const timer = useRef(null)

    const getWeight = async () => {
        if (gettingWeight) return
        setGettingWeight(true)

        const result = await print(printerIP, { type: 'weight' })
        if (result) {
            setWeight(result.data)
        }

        setGettingWeight(false)

        timer.current = setTimeout(() => {
            getWeight()
        }, 1000)
    }

    useEffect(() => {
        if (timer.current)
            clearTimeout(timer.current);

        if (printerIP) {
            getWeight()
        }

    }, [printerIP])

    useEffect(() => {
        if (!product) return
        if (product.weightable) {
            changeAmount(weight / 1000)
        }
    }, [weight, product])

    useEffect(() => {
        if (!product) return
        if (product.weightable) {
            getWeight()
        }
    }, [product])

    useEffect(() => {
        return () => timer.current ? clearTimeout(timer.current) : () => { }
    }, []);



    let printParams = useMemo(() => {
        if (!product) return {}

        let sostav = ''
        let storage = ''
        let placement = ''
        let barcode = ''
        let klet = ''
        let calories = ''
        let ugl = ''
        let bel = ''
        let fats = ''
        let valid_hours = 0;
        let producer = ''

        if (product.placements && product.placements.length) {
            placement = product.placements[0].ware.full_name
        }

        if (product.barcodes.length) {
            barcode = product.barcodes[0]
        }

        product.properties.map(property => {
            if (property.property_id == 1 && property.value) {
                sostav = property.value
            }
            if (property.property_id == 3 && property.value) {
                storage = property.value
            }
            if (property.property_id == 9 && property.value) {
                klet = property.value
            }
            if (property.property_id == 4 && property.value) {
                calories = property.value
            }
            if (property.property_id == 7 && property.value) {
                ugl = property.value
            }
            if (property.property_id == 5 && property.value) {
                bel = property.value
            }
            if (property.property_id == 8 && property.value) {
                valid_hours = property.value
            }
            if (property.property_id == 72 && property.value) {
                producer = property.value
            }
            if (property.property_id == 6 && property.value) {
                fats = property.value
            }
        })

        const params = {
            product_id: product.id,
            placement: placement,
            name: product.name,
            manager: '--',
            fats: fats,
            weight: product.weight,
            barcode: barcode,
            sostav: sostav,
            storage: storage,
            ed_izm: product.unit_name,
            klet: klet,
            calories: calories,
            ugl: ugl,
            bel: bel,
            valid_till: dateToYMD(dateAdd(new Date, 'hour', valid_hours)),
            company: user.supplier.name
        }

        return params
    }, [product])

    const startPrinting = async () => {
        printParams.manufactured = todayDatetime()

        if (product.weightable) {
            printParams.type = 8
            printParams.weight = amount

            await print(printerIP, printParams)
        } else {
            printParams.type = 9
            printParams.copies = amount

            await print(printerIP, printParams)
        }

        onClose()
    }

    const startProduction = async () => {
        if (!printerIP.length) {
            alert('Не указан адрес принтера печати ШК!');
            return;
        }

        if (isPrinting) return false;
        setIsPrinting(true)

        startPrinting()

        setIsPrinting(false)
    }

    const changeAmount = (newValue) => {
        if (product.weightable) {
            setAmount(newValue)
            return
        }

        let stringValue = newValue.toString()

        if (stringValue.substr(- 1) == '.' || (stringValue.substr(- 1) == '' && stringValue.length > 1)) {
            setAmount(amount)
            return
        }

        if (!stringValue.length) {
            newValue = 0
        }

        setAmount(Math.ceil(stringValue))
    }



    return (
        <div className="pint_hold">
            <div className="pint_drop" onClick={ onClose }></div>
            <div className="pint_block">
                <div className=" pint_amountHolder ">
                    <div className=" pint_header ">
                        { product.weightable ? 'Вес:' : 'Количество стикеров:' }
                    </div>
                    <div className=" pint_amountBlock ">
                        { amount }
                    </div>
                </div>
                { product.weightable ?
                    null
                    : <NumberPad
                        amount={ amount }
                        updateAmount={ changeAmount }
                        allowFloat={ product.weightable }
                    />
                }

                <div className=" pint_footer ">
                    <a onClick={ () => startProduction() } className="print-sticker-btn">
                        Распечатать
                    </a>
                </div>
            </div>
        </div>
    )
}

export default ProductionInterface